function TOKEN_OR(...rules) {
    return `(?:${rules.map(rule=>`(?:${rule})`).join('|')})`;
}
export const CSS_TOKEN = {
    IDENTIFIER: `[A-z0-9-_]+`,
    DOUBLE_QUOTED_STRING: `"(?:\\\\"|[^"])+"`,
    SINGLE_QUOTED_STRING: `'(?:\\\\'|[^'])+'`,
    START_SPACE: /^\s?[^\s]/,
    END_SPACE: /[^\s]\s?$/,
    QUOTES: /^((\'.+\')|(\".+\"))$/,
    SPACE: /\s/,
    ESCAPED_SINGLE_QUOTES: /^(\\'|[^'])+$/,
    ESCAPED_DOUBLE_QUOTES: /^(\\"|[^"])+$/
};

CSS_TOKEN.FONT_FAMILY_NAME = TOKEN_OR(CSS_TOKEN.DOUBLE_QUOTED_STRING, CSS_TOKEN.SINGLE_QUOTED_STRING, CSS_TOKEN.IDENTIFIER);


// WEBPACK FOOTER //
// ./lib/css-property-parser/index.js